export const BRANDING = {
  appName: 'The Mill',
  appShortName: 'The Mill',
  assistantName: 'True',
  companyName: 'True Classic',
  emailDraftStorageKey: 'tc-hq-email-studio-drafts-v2',
} as const;

export function normalizeAssistantDisplayName(name?: string | null): string {
  const trimmed = name?.trim();
  if (!trimmed) return BRANDING.assistantName;
  if (trimmed.toLowerCase() === 'ai assistant') return BRANDING.assistantName;
  return trimmed;
}
